/**
 * Equibook Version Configuration
 * 
 * Update this file when releasing new versions.
 * Format: MAJOR.MINOR (e.g., 1.25)
 * 
 * Version History:
 * - 1.0: Initial release
 * - 1.25: Notification system overhaul (automatic notifications, targeting rules)
 * - 1.31: Planning views improvements (week/month navigation, double-click create)
 * - 1.32: PWA cache fix, horse card photo fix
 * - 1.32c fix :titre Equibook trop haut menu bar et pages
 * - 1.32d fix : design des cartes cours passé&, notifictions
 * - 1.40 : workflow creation compte pour les mineurs
 * - 1.45 : tableau de decompte pour instructeur et cavaliers
 * - 1.50 : nouveau mode de creaion de compte (approbation + lien d'activation)
 * - 1.55 : Tab "Décompte" : implémenttion nouvelle focntionnamlités (tri/sélection) + lien vers facturation Equibook
 * - 1.60a : Debug +++ +logo Equibook - superadmin : new actions on new club
 * - 1.60b : Ajout info manquantes dans carte cavalier
 * - 1.61 : Fix boucle de rechargement page d'accueil (Service Worker)
 * - 1.62 : Extension journalisation activités (chevaux, groupes, cours, profils, notifications)
 * - 1.63 : Journalisation cours/absences + fix modal ajout cavalier (filtrage par critères)
 * - 1.63b : Ajout module statistique super admin 
 *           Amlélioration sélection cavalier pour ajout planning
 * - 1.70 : Nouvel aspect de la landing page
 */

export const APP_VERSION = "1.70a";
export const APP_NAME = "Equibook";
export const FULL_VERSION = `${APP_NAME} v${APP_VERSION}`;
